import { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { useUsersStore } from '@/stores/users';
import { ERouterNames, EUserRoles } from '@/types';

type Props = {
  roles: EUserRoles[];
};

export const AccessControlLayout = ({ roles }: Props) => {
  const navigate = useNavigate();
  const { allRoles, isSuperAdmin, orgAdminOrganizationIds } = useUsersStore(
    (state) => ({
      allRoles: state.getAllRoles(),
      isSuperAdmin: state.checkIsSuperAdmin(),
      orgAdminOrganizationIds: state.getOrgAdminOrganizationIds(),
    }),
  );
  // Org admins and super admins hold their access outside of institution
  // roles, so an ADMIN requirement must also accept them.
  const isOrgAdmin = isSuperAdmin || !!orgAdminOrganizationIds.length;

  useEffect(() => {
    const check = roles.some((item) => {
      return (
        allRoles.includes(item) || (item === EUserRoles.ADMIN && isOrgAdmin)
      );
    });
    if (!check) {
      navigate(ERouterNames.ROUTE_ME);
    }
  }, [allRoles, isOrgAdmin, navigate, roles]);

  return <Outlet />;
};
